/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReadStatusDto
 */
export interface ReadStatusDto {
    /**
     * The last seen message sequence number.
     * @type {number}
     * @memberof ReadStatusDto
     */
    lastMessageSeen?: number;
    /**
     * The unread message count.
     * @type {number}
     * @memberof ReadStatusDto
     */
    unreadMessageCount?: number;
}

/**
 * Check if a given object implements the ReadStatusDto interface.
 */
export function instanceOfReadStatusDto(value: object): value is ReadStatusDto {
    return true;
}

export function ReadStatusDtoFromJSON(json: any): ReadStatusDto {
    return ReadStatusDtoFromJSONTyped(json, false);
}

export function ReadStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReadStatusDto {
    if (json == null) {
        return json;
    }
    return {
        
        'lastMessageSeen': json['last_message_seen'] == null ? undefined : json['last_message_seen'],
        'unreadMessageCount': json['unread_message_count'] == null ? undefined : json['unread_message_count'],
    };
}

export function ReadStatusDtoToJSON(json: any): ReadStatusDto {
    return ReadStatusDtoToJSONTyped(json, false);
}

export function ReadStatusDtoToJSONTyped(value?: ReadStatusDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'last_message_seen': value['lastMessageSeen'],
        'unread_message_count': value['unreadMessageCount'],
    };
}

